import { render, staticRenderFns } from "./DefaultValue.vue?vue&type=template&id=4668ee14"
import script from "./DefaultValue.vue?vue&type=script&lang=js"
export * from "./DefaultValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports